import React from 'react';
import styled from 'styled-components'
import {useReactiveVar} from "@apollo/client";

import {isApiVar} from '../../cache'


const BackLayer = (props) => {
  const isApi = useReactiveVar(isApiVar);


  return(
    <Wrapper isApi={isApi}/>
  )
};

const Wrapper = styled.div(props => ({
	position:"absolute",
  maxWidth:500,
  width:500,
  height:"100%",
  top:0,
  zIndex:-1,
  right:0,
  backgroundColor: props.isApi ? "#FFFFFF" : "#FFFFFF",
  boxShadow: props.isApi ? "inset 0px 0px 30px rgba(0, 0, 0, 0.04)" : "inset 0px 0px 30px rgba(0, 0, 0, 0.04)",
  "@media (max-width: 1280px)": {
    width:props.isApi ? 400 : 500,
  },
  "@media (max-width: 1080px)": {
    width:props.isApi ? 400 : "46%",
    backgroundColor:props.isApi ? "transparent" : "#FFFFFF",
  },
  "@media (max-width: 650px)": {
    width:props.isApi ? 400 : "34%",
  }
}));

export default BackLayer
